import { Field, Text } from "@sitecore-jss/sitecore-jss-react";
import React from "react";

import { yesOrNo } from "../../../Enums/enumValues";
import { YesOrNo } from "../../../interfaces/enum";
import { ModelState } from "../../../interfaces/modelState";
import { Card } from "../../card/Card";
import HorizontalRadioInput, { RadioOption } from "../../InputFields/HorizontalRadioInput";
import { V5 } from "../../InputFields/validator/validators";

interface Props {
  fields: Record<string, Field<string>>;
  modelState: ModelState | null;
  setModelState: (updatedModelState: ModelState) => void;
  name: string;
  validationPropertyName: string;
  selectedValue?: YesOrNo;
  onUpdateCrosswiseInsured: (crosswiseInsured: YesOrNo) => void;
}

export const CrosswiseInsured = ({
  name,
  fields,
  selectedValue,
  validationPropertyName,
  modelState,
  setModelState,
  onUpdateCrosswiseInsured,
}: Props) => (
  <Card>
    <h2>
      <Text field={fields.TitleCrosswiseInsured}></Text>
    </h2>
    <HorizontalRadioInput
      name={name}
      fieldData={fields}
      selectedValue={selectedValue}
      onChange={onUpdateCrosswiseInsured}
      modelState={modelState}
      setModelState={setModelState}
      propertyName={validationPropertyName}
      options={yesOrNo() as RadioOption<YesOrNo>[]}
      validators={[V5]}
    />
  </Card>
);
